// extracted by mini-css-extract-plugin
module.exports = {"root":"BackButton_root__g9PG8","before":"BackButton_before__zZGaj","arrow":"BackButton_arrow__wMcx2","content":"BackButton_content___5fWJ"};